import React, { useState } from 'react';

import { Input } from 'antd';
import Axios from 'axios';

import styled from 'styled-components';

import { NwButton, NwLinkButton } from '@components/Gui/NwButton';
import NwModal from '@components/Gui/NwModal';

import { usePackageContext } from '../PackageContext';

const Wrapper = styled.div`
    .new-group-box {
        padding-top: 1rem;
        margin-top: 1rem;
        border-top: ${(props) => props.theme.DefaultBorder};
        p {
            margin: 0;
        }
        .field-and-button {
            margin-top: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 0.5rem;
        }
    }
`;

const GroupModal = ({ show, onClose, packageModelIDs, currentGroup, clearSelected }) => {
    const [newGroupName, setNewGroupName] = useState('');

    const packageContextValue = usePackageContext();
    const { groupedPackage, afterUpdatePackage } = packageContextValue;
    const { GroupNames, ModelIdsByGroup } = groupedPackage;

    const getNewOrder = (groupName) => {
        const newOrder = [];
        let foundGroup = false;
        for (const g of ModelIdsByGroup) {
            const groupModels = [...g.modelIDs];
            const groupModelsWithoutSelected = groupModels.filter((modelID) => !packageModelIDs.includes(modelID));
            if (g.group === groupName) {
                foundGroup = true;
                groupModelsWithoutSelected.push(...packageModelIDs);
            }
            newOrder.push(...groupModelsWithoutSelected);
        }
        if (!foundGroup) {
            newOrder.push(...packageModelIDs);
        }
        return newOrder;
    };

    const onSaveNewGroup = () => {
        onSaveGroup(newGroupName);
    };

    const onSaveGroup = async (groupName) => {
        try {
            if (groupName === 'No groups') {
                const dataClearGroup = {
                    PackageID: groupedPackage.ID,
                    ModelIDs: [...packageModelIDs],
                    ModelOrder: getNewOrder(),
                };
                await Axios.put('/PackageModels/ClearGroup', dataClearGroup);
            } else {
                const dataGroupName = {
                    PackageID: groupedPackage.ID,
                    ModelIDs: [...packageModelIDs],
                    ModelOrder: getNewOrder(groupName),
                    GroupName: groupName,
                };
                await Axios.put('/PackageModels/SetGroup', dataGroupName);
            }
            afterUpdatePackage();
            clearSelected();
            onClose();
        } catch (error) {
            console.error('Update Group of PackageModel => ', error);
        }
    };

    return (
        <NwModal
            title="Change Group"
            open={show}
            footer={null}
            onCancel={() => {
                onClose();
            }}
        >
            <Wrapper>
                <p>
                    <NwLinkButton label="Clear Group" onClick={() => onSaveGroup('No groups')} />
                </p>
                {GroupNames &&
                    GroupNames.filter((name) => name).length > 0 &&
                    GroupNames.map((groupName) => (
                        <p>
                            <NwLinkButton
                                disabled={groupName === currentGroup}
                                label={groupName}
                                onClick={() => onSaveGroup(groupName)}
                            />
                        </p>
                    ))}
                <div className="new-group-box">
                    <p>New Package Group</p>
                    <div className="field-and-button">
                        <Input value={newGroupName} onChange={(e) => setNewGroupName(e.target.value)} />
                        <NwButton primary label="Save" loadingLabel="Updating..." onClick={() => onSaveNewGroup()} />
                    </div>
                </div>
            </Wrapper>
        </NwModal>
    );
};

export default GroupModal;
